import React from 'react';

export default function TagsCircle() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#18181B' />
      <path
        d='M7.99967 10.0063V9.99967M13.9997 7.33301L18.1997 11.533C18.3488 11.6817 18.4672 11.8583 18.5479 12.0528C18.6287 12.2472 18.6703 12.4558 18.6703 12.6663C18.6703 12.8769 18.6287 13.0854 18.5479 13.2799C18.4672 13.4744 18.3488 13.651 18.1997 13.7997L15.333 16.6663M9.99967 7.33301H5.33301V11.9997L9.52634 16.193C10.153 16.8197 11.1797 16.8197 11.8063 16.193L14.193 13.8063C14.8197 13.1797 14.8197 12.153 14.193 11.5263L9.99967 7.33301Z'
        stroke='#A1A1AA'
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
